/* eslint-disable func-names */
/* eslint-disable no-console */
/* eslint-disable no-continue */
/* eslint-disable */
// eslint-disable-next-line object-curly-newline
import React, { useState, useEffect, useRef, useCallback } from 'react';
import ReactDOMServer from 'react-dom/server';
import { format, getDay, getISOWeek } from 'date-fns';
import moment from 'moment';
import store from './store';
import authActions from '../Actions/auth.actions';
import { timeFilterMap } from '../Constants/analytics.constansts';
import { Chip } from '@mui/material';
import { Add } from '@mui/icons-material';
import { deleteCookie, getCookie } from '@/Services/Storage Services';
import { useDispatch } from 'react-redux';
import { analyticsAction, formActions } from '@/Actions';
import productProcessMapServices from '@/Services/Analytics Services/product-process-map.services';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
// import { notificationServices } from '../Services';

export function objectContainsProperty(obj, prop) {
	return Object.prototype.hasOwnProperty.call(obj, prop);
}
export function cloneDeep(object) {
	return JSON.parse(JSON.stringify(object));
}

export function waitForAPI(state, key, subKey = false) {
	if (!state) {
		return [];
	}
	if (objectContainsProperty(state, key)) {
		if (subKey) {
			return state[key][subKey];
		}
		return state[key];
	}
	return [];
}

export function isObject(object) {
	return object != null && typeof object === 'object';
}

export function isEmpty(obj) {
	if (!isObject(obj)) return true;
	if (obj.length === 0) return true;
	const hasProperty = Object.keys(obj).some((prop) => {
		return objectContainsProperty(obj, prop);
	});
	return !hasProperty && JSON.stringify(obj) === JSON.stringify({});
}

export const imageToBase64 = (image) => {
	return new Promise((resolve) => {
		if (typeof image === 'string') {
			resolve(image);
		}
		const reader = new FileReader();
		reader.readAsDataURL(image);
		reader.onloadend = () => {
			resolve(reader.result);
		};
	});
};

export const generateImageUrl = (file) => {
	if (file) {
		if (typeof file === 'string') {
			return file;
		}
		return URL.createObjectURL(file);
	}
	return '';
};

export const generateRandomKey = () => {
	return {
		key: Math.random(),
	};
};

export const generateRequiredProps = (required) => {
	// eslint-disable-next-line object-curly-newline
	return required ? { required } : {};
};

export const generateDisabledProps = (disabled) => {
	// eslint-disable-next-line object-curly-newline
	return disabled ? { disabled } : {};
};

export const generateCheckedProps = (checked) => {
	// eslint-disable-next-line object-curly-newline
	return checked ? { checked } : {};
};

export const generateImageUploadButton = ({ isDisabled, label }) => {
	if (isDisabled) {
		return <></>;
	}
	return label;
};

export const generateImageEditButton = ({ isEdit, button }) => {
	if (isEdit) {
		return button;
	}
	return <></>;
};

export function generateUniqueID() {
	const timestamp = Date.now(); // Get current timestamp in milliseconds
	const randomNum = Math.floor(Math.random() * 10000);

	const uniqueID = `${timestamp}${randomNum}`;
	return uniqueID;
}

export function deepEqual(object1, object2) {
	const keys1 = Object.keys(object1);
	const keys2 = Object.keys(object2);
	if (keys1.length !== keys2.length) {
		return false;
	}
	return keys1.reduce((acc, curr) => {
		const key = curr;
		const val1 = object1[key];
		const val2 = object2[key];
		const areObjects = isObject(val1) && isObject(val2);
		if (
			(areObjects && !deepEqual(val1, val2)) ||
			(!areObjects && val1 !== val2)
		) {
			return false;
		}
		return true;
	}, false);
}

/**
 *
 * @param {string} queryURL
 * @param {object} params
 * @returns {string} url with query params
 */
export function toQueryStringURL(queryURL, params) {
	const url = new URL(queryURL);
	Object.keys(params).forEach((key) => {
		return url.searchParams.append(key, params[key]);
	});
	return url;
}

/**
 *
 * @param {string} queryURL
 * @param {object} params
 * @returns {string} url with query params
 */
export function appendAsQueryString(queryURL, params) {
	let url = queryURL;
	Object.entries(params).forEach(([key, value]) => {
		if (!url?.includes('?')) {
			url = `${url}?${key}=${value ?? ''}`;
		} else {
			url = `${url}&${key}=${value ?? ''}`;
		}
	});
	return url;
}

/**
 *
 * @param {string} queryURL
 * @param {array} params
 * @returns {string} url with query params
 */
export function toPathStringURL(queryURL, pathAppend) {
	let url = queryURL;
	pathAppend.forEach((key) => {
		// eslint-disable-next-line prefer-template
		url += '/' + key;
	});
	return url;
}

export function convertedUnitValue(value, unit = 'gm') {
	if (unit === 'gm') {
		if (!(value < 1000)) {
			return `${Number(value / 1000).toFixed(2)}kg`;
		}
		// Check if the value has a decimal part
		if (value % 1 !== 0) {
			// Round the number to two decimal places
			return `${Number(value).toFixed(2)}gm`;
		}
		return `${Number(value)}gm`;
		// If it's an integer, return it as is
	}
	if (!(value < 1000)) {
		return `${Number(value / 1000).toFixed(2)}K`;
	}
	return `${Number(value)}`;
}

export const regExpHelper = {
	mobile: /^\d{10}$/,
	email: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/,
	OTP: /^\d{6}$/,
	hex: /^#([A-Fa-f0-9]{3}){1,2}$/,
};

export function validateForm(errors, withError = false) {
	let validationError = [true, ''];
	const isValid = !Object.keys(errors).some((error) => {
		validationError = [false, errors[error]];
		return errors[error].length > 0;
	});
	if (withError) {
		return validationError;
	}
	return isValid;
}

function getWindowDimensions() {
	const { innerWidth: width, innerHeight: height } = window;
	return {
		width,
		height,
	};
}

export function useWindowDimensions() {
	const [windowDimensions, setWindowDimensions] = useState(
		getWindowDimensions()
	);

	useEffect(() => {
		function handleResize() {
			setWindowDimensions(getWindowDimensions());
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);
	return windowDimensions;
}

function getScrollFromBottom() {
	const distanceFromBottom =
		document.documentElement.scrollHeight -
		(window.scrollY + window.innerHeight);
	return distanceFromBottom;
}

export function useWindowScrollFromBottom() {
	const [distanceFromBottom, setDistanceFromBottom] = useState(
		getScrollFromBottom()
	);
	useEffect(() => {
		function handleScroll() {
			setDistanceFromBottom(getScrollFromBottom());
		}
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);
	return {
		distanceFromBottom,
	};
}

export function disableInputIncrementWheel(event) {
	if (!event.target.matches('input[type=number]')) return;
	event.preventDefault();
}

export function disableInputIncrementKey(event) {
	if (!event.target.matches('input[type=number]')) return;
	if (event.keyCode === 38 || event.keyCode === 40) {
		event.preventDefault();
	}
}

export const on = (selector, eventType, childSelector, eventHandler) => {
	const elements = document.querySelectorAll(selector);
	elements.forEach((element) => {
		element.addEventListener(eventType, (eventOnElement) => {
			if (eventOnElement.target.matches(childSelector)) {
				eventHandler(eventOnElement);
			}
		});
	});
};

export function hexToRGB(hex = '#000000') {
	let temp;
	if (regExpHelper.hex.test(hex)) {
		temp = hex.substring(1).split('');
		if (temp.length === 3) {
			temp = temp.reduce((acc, curr) => {
				return [...acc, curr, curr];
			}, []);
		}
		temp = `0xc${temp.join('')}`;
		return `${[(temp >> 16) & 255, (temp >> 8) & 255, temp & 255].join(
			', '
		)}`;
	}
	throw new Error('Bad Hex');
}

export function inputHelper(e) {
	const fieldName = e?.target?.name;
	const fieldValue =
		e?.target?.type === 'checkbox' ? e?.target?.checked : e?.target?.value;
	const dataset = e?.currentTarget?.dataset || e?.target?.dataset || {};
	return {
		fieldName,
		fieldValue,
		dataset,
	};
}

export function getMonthNumber(month) {
	const MONTH_MAP = {
		Jan: 1,
		Feb: 2,
		Mar: 3,
		Apr: 4,
		May: 5,
		Jun: 6,
		Jul: 7,
		Aug: 8,
		Sep: 9,
		Oct: 10,
		Nov: 11,
		Dec: 12,
	};

	return MONTH_MAP?.[month] ?? null;
}

export function getMonthsWeek(year, weeks, month) {
	// get the first day of year
	const firstDayOfMonth = new Date(year, timeFilterMap.monthNumber[month], 1);
	// get year/ ISO week number of first day of the month
	const weekOfFirstDay = getISOWeek(firstDayOfMonth);
	// result is ISO week number of selected week - week of first day
	// + 1 to get 1 for first week
	return weeks - weekOfFirstDay + 1;
}
export function ordinalSuffixOf(i) {
	const j = i % 10;
	const k = i % 100;
	if (j === 1 && k !== 11) {
		return `${i}st`;
	}
	if (j === 2 && k !== 12) {
		return `${i}nd`;
	}
	if (j === 3 && k !== 13) {
		return `${i}rd`;
	}
	return `${i}th`;
}
// export function handleResponse(response) {
// 	console.log('calling1');
// 	return response.text().then((text) => {
// 		const data = text && JSON.parse(text);
// 		if (data.status === 'Failed' || data.errorMessage) {
// 			let error =
// 			data.errorMessage || data.message || data.responseMessage;
// 			const token = JSON.parse(getCookie('user'))?.token;
// 			if ((error === 'Auth_Invalid' || error === 'Unauthorized Access') && token) {
// 				console.log(token, 'tocken');
// 				deleteCookie('user');
// 				error = 'Your session has expired';
// 				store.dispatch(authActions.toggleLogout(true));
// 				return null;
// 			}
// 			// if it's not a loading notification, display error message
// 			console.log('runningdown');
// 			if (!store.getState().auth.isLoading) {
// 				store.dispatch(authActions.toggleLoading(false));
// 				// notificationServices.generateNotification({
// 				// 	type: 'error',
// 				// 	message: error,
// 				// });
// 			}
// 			return Promise.reject(error);
// 		}
// 		return data;
// 	});
// }
export const classes = (...args) => {
	return args.join(' ');
};
export function getDayName(dayNumber) {
	const dayName = [
		'Sunday',
		'Monday',
		'Tuesday',
		'Wednesday',
		'Thursday',
		'Friday',
		'Saturday',
	];
	return dayName[dayNumber];
}
export function convertTo24HourFormatTo12Hour(timeString) {
	const H = timeString;
	const h = H % 12 || 12;
	const ampm = H < 12 || H === 24 ? 'AM' : 'PM';
	return `${h} ${ampm}`;
}

export function cpkComparator(a, b, isAscending = true) {
	let factor = 1;
	if (!isAscending) factor = -1;
	if (a === 'Perfect process') {
		return 1 * factor;
	}
	if (b === 'Perfect process') {
		return -1 * factor;
	}
	if (a === 'Not defined') {
		return -1 * factor;
	}
	if (b === 'Not defined') {
		return 1 * factor;
	}
	return (a - b) * factor;
}

export function getDayNameFromDate(timeStamp) {
	const [dateString] = timeStamp.split(',');
	const [month, date, year] = dateString.split('/');
	const dayNumber = getDay(new Date(year, month - 1, date));
	return getDayName(dayNumber);
}

export function getDateFilterString(DATE_FILTER = {}) {
	return Object.keys(DATE_FILTER).reduce(
		(accSelectedDate, currSelectionType, idx) => {
			const isFirst = idx === 0;
			if (
				DATE_FILTER[currSelectionType] &&
				currSelectionType.toUpperCase() !== 'WEEK'
			) {
				if (!isFirst) {
					// eslint-disable-next-line no-param-reassign
					accSelectedDate += ', ';
				}
				// eslint-disable-next-line no-param-reassign
				accSelectedDate += `${currSelectionType.toUpperCase()}: ${DATE_FILTER[currSelectionType]
					}`;
			}
			return accSelectedDate;
		},
		''
	);
}

export function useClientRect() {
	const ref = useRef(null);

	const getClientRect = useCallback(() => {
		return ref?.current?.getBoundingClientRect?.();
	}, []);

	return [getClientRect, ref];
}

export function checkFormField(obj = {}, notMandatory = '') {
	const keyArr = Object.keys(obj);
	let emptyKey = '';
	for (let i = keyArr?.length - 1; i >= 0; i--) {
		if (obj[keyArr[i]] === '' && keyArr[i] !== notMandatory) {
			emptyKey = keyArr[i];
		}
	}
	return emptyKey;
}

export const weekDays = [
	{
		id: 0,
		label: 'Monday',
		key: 'M',
	},
	{
		id: 1,
		label: 'Tuesday',
		key: 'T',
	},
	{
		id: 2,
		label: 'Wednesday',
		key: 'W',
	},
	{
		id: 3,
		label: 'Thursday',
		key: 'T',
	},
	{
		id: 4,
		label: 'Friday',
		key: 'F',
	},
	{
		id: 5,
		label: 'Saturday',
		key: 'S',
	},
	{
		id: 6,
		label: 'Sunday',
		key: 'S',
	},
];

export const keyPressHandler = (keyPressed, listData, listIndex) => {
	let newListItem = null;
	if (keyPressed === 'ArrowRight' || keyPressed?.toLowerCase() === 'd') {
		if (listIndex >= 0 && listIndex < listData.length - 1) {
			newListItem = listData?.[listIndex + 1];
		} else {
			return false;
		}
	} else if (
		keyPressed === 'ArrowLeft' ||
		keyPressed?.toLowerCase() === 'a'
	) {
		if (listIndex > 0) {
			newListItem = listData?.[listIndex - 1];
		} else {
			return false;
		}
	}
	return newListItem;
};

export const handleExcelDownload = (
	header,
	fileData,
	fileName,
	wrapInQuotes = false
) => {
	const downloadBtn = document.createElement('a');

	// Escape a single CSV field per RFC 4180: wrap in double quotes when the
	// value contains a comma, double quote or newline, and double up any
	// embedded quotes. forceQuotes preserves the legacy wrapInQuotes behaviour.
	const escapeCsvField = (value, forceQuotes = false) => {
		const str = value === null || value === undefined ? '' : String(value);
		const needsQuotes = forceQuotes || /[",\n\r]/.test(str);
		const escaped = str.replace(/"/g, '""');
		return needsQuotes ? `"${escaped}"` : escaped;
	};

	const csvData = [header, ...fileData].map((item) => {
		return item.map((e) => {
			return escapeCsvField(e, wrapInQuotes);
		});
	});

	const csv = `${csvData
		.map((e) => {
			return e.join(',');
		})
		.join('\n')}`;

	const encodedValue = new Blob([csv], {
		type: 'text/csv',
	});
	downloadBtn.href = window.URL.createObjectURL(encodedValue);
	downloadBtn.target = '_blank';
	downloadBtn.download = fileName ?? 'Excel';
	downloadBtn.click();
};

export function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1)?.toLowerCase();
}

export const unitTypes = {
	gram: {
		postConversionUnit: 'kg',
		unitDisplay: 'g',
		higherUnitDivisionFactor: 1000,
		isBaseUnit: true,
		toFixedDivision: 3,
	},
	oz: {
		postConversionUnit: 'lbs',
		unitDisplay: 'oz',
		higherUnitDivisionFactor: 16,
		isBaseUnit: true,
	},
	count: {
		postConversionUnit: 'pc',
		unitDisplay: 'pc',
		higherUnitDivisionFactor: 1,
		toFixedDivision: 0
	},
	floz: {
		postConversionUnit: 'gal',
		unitDisplay: 'floz',
		higherUnitDivisionFactor: 128,
		isBaseUnit: true,
	},
	litre: {
		postConversionUnit: 'ml',
		unitDisplay: 'l',
		higherUnitDivisionFactor: 1 / 1000,
		isHigherUnit: true,
	},
	ltr: {
		postConversionUnit: 'ml',
		unitDisplay: 'ltr',
		higherUnitDivisionFactor: 1 / 1000,
		isHigherUnit: true,
	},
	ml: {
		postConversionUnit: 'ltr',
		unitDisplay: 'ml',
		higherUnitDivisionFactor: 1000,
		isBaseUnit: true,
	},
	kg: {
		postConversionUnit: 'g',
		unitDisplay: 'Kg',
		higherUnitDivisionFactor: 1 / 1000,
		isHigherUnit: true,
	},
	lbs: {
		postConversionUnit: 'oz',
		unitDisplay: 'lbs',
		higherUnitDivisionFactor: 1 / 16,
	},
	lb: {
		postConversionUnit: 'oz',
		unitDisplay: 'lbs',
		higherUnitDivisionFactor: 1 / 16,
		isHigherUnit: true,
	},
	gal: {
		postConversionUnit: 'floz',
		unitDisplay: 'gal',
		higherUnitDivisionFactor: 1 / 128,
		isHigherUnit: true,
	},
};

export function getPriceConvertedQuantity(
	price,
	unit = 'gram',
	invertValue = false
) {
	let no = Number(price);
	// eslint-disable-next-line no-restricted-globals
	if (isNaN(no)) {
		if (price === undefined || price === null) {
			return 0;
		}
		return price;
	}

	no = Number(no);
	if (unit === 'count') {
		return no;
	}
	if (invertValue) {
		return Number.parseFloat(
			no / unitTypes?.[unit]?.higherUnitDivisionFactor
		).toFixed(unitTypes?.[unit]?.toFixedDivision ?? 2);
	}
	const newNo = Number.parseFloat(
		no * unitTypes?.[unit]?.higherUnitDivisionFactor
	).toFixed(unitTypes?.[unit]?.toFixedDivision ?? 2);
	return newNo;
}

export function getUnitConvertedQuantity(
	quantity,
	unit = 'gram',
	allowConvertBaseUnit = true,
	allowConvertHigherUnit = true,
	force = false,
	rawQty = false,
) {
	let qty = rawQty ? quantity : Number(quantity);
	// eslint-disable-next-line no-restricted-globals
	if (isNaN(qty) || qty === null) {
		qty = 0;
	}
	const [_, decimalPart = ''] = qty.toString().split('.');
	if (!allowConvertBaseUnit && unitTypes?.[unit]?.isBaseUnit) {
		return qty;
	}
	if (!allowConvertHigherUnit && unitTypes?.[unit]?.isHigherUnit) {
		return qty;
	}
	if (qty >= unitTypes?.[unit]?.higherUnitDivisionFactor || force) {
		const newNo = Number.parseFloat(
			qty / unitTypes?.[unit]?.higherUnitDivisionFactor
		).toFixed(unitTypes?.[unit]?.toFixedDivision ?? 3);
		// if (newNo >= 1000 && !inThousands) {
		// 	return Number.parseFloat(newNo / 1000).toFixed(
		// 		unitTypes?.[unit]?.toFixedDivision ?? 1
		// 	);
		// }
		return newNo;
	}
	const newNo = decimalPart.length > 3
		? Number.parseFloat(qty).toFixed(unitTypes?.[unit]?.toFixedDivision ?? 3)
		: qty
	return newNo;
}

export function getUnitConvertedUnit(
	quantity,
	unit = 'gram',
	force = false
	// inThousands = false
) {
	let qty = Number(quantity);
	// eslint-disable-next-line no-restricted-globals
	if (isNaN(qty)) {
		qty = 0;
	}
	if (force) {
		return unitTypes?.[unit]?.postConversionUnit;
	}
	if (qty === 0) {
		return unitTypes?.[unit]?.unitDisplay ?? '-';
	}
	if (qty >= unitTypes?.[unit]?.higherUnitDivisionFactor || force) {
		// const newNo = Number.parseFloat(
		// 	qty / unitTypes?.[unit]?.higherUnitDivisionFactor
		// ).toFixed(unitTypes?.[unit]?.toFixedDivision ?? 1);
		// if (newNo >= 1000 && !inThousands) {
		// 	// eslint-disable-next-line prefer-template
		// 	return 'K ' + unitTypes?.[unit]?.postConversionUnit;
		// }
		return unitTypes?.[unit]?.postConversionUnit;
	}
	return unitTypes?.[unit]?.unitDisplay;
}

export function convertWeightUnit(
	quantity,
	unit = 'gram',
	measurement = 'IND',
	force = false
) {
	if (unit === null) {
		// Set a default value for unit if it's null or undefined
		// eslint-disable-next-line no-param-reassign
		unit = 'gram'; // You can set any default unit you prefer
	}
	// eslint-disable-next-line eqeqeq
	if (quantity == null || quantity == undefined) {
		return '-';
	}
	return (
		getUnitConvertedQuantity(quantity, unit, true, true, force) + ' ' +
		getUnitConvertedUnit(quantity, unit, force)
	);
}

export function reverseUnitAndQtyNew(qty, unit) {
	if (!qty && qty !== 0) {
		return [0, unit];
	}

	let newQty = qty;
	let newUnit = unit;

	if (unit === 'kg') {
		newUnit = 'gram';
		newQty = Math.round(qty * 1000);
	}
	if (unit === 'ltr') {
		newUnit = 'ml';
		newQty = Math.round(qty * 1000);
	}
	if (unit === 'lb') {
		newUnit = 'oz';
		newQty = Math.round(qty * 16);
	}
	if (unit === 'gal') {
		newUnit = 'floz';
		newQty = Math.round(qty * 128);
	}

	return [newQty, newUnit];
}

export function getOurProductUnit(userUnit, raiseError = false) {
	let unit = '';
	let isHigherUnit = false;

	if (['gram', 'gm', 'g', 'Gram', 'Gm', 'G'].includes(userUnit)) {
		unit = 'gram';
		isHigherUnit = false;
	}
	if (['ml', 'mL', 'Milliliter', 'Ml', 'ML'].includes(userUnit)) {
		unit = 'ml';
		isHigherUnit = false;
	}
	if (['count', 'Count', 'C', 'pieces', 'piece', 'pc'].includes(userUnit)) {
		unit = 'count';
		isHigherUnit = false;
	}
	if (['Kg', 'kg', 'KG', 'Killogram'].includes(userUnit)) {
		unit = 'kg';
		isHigherUnit = true;
	}
	if (['L', 'l', 'Litre', 'ltr'].includes(userUnit)) {
		unit = 'ltr';
		isHigherUnit = true;
	}
	if (['oz', 'Oz', 'OZ', 'Ounce', 'ounce'].includes(userUnit)) {
		unit = 'oz';
		isHigherUnit = false;
	}
	if (
		['floz', 'Floz', 'FLOZ', 'FlOz', 'Fluid Ounce', 'fluid ounce'].includes(
			userUnit
		)
	) {
		unit = 'floz';
		isHigherUnit = false;
	}
	if (['lbs', 'Lbs', 'LBS', 'Pound', 'pound'].includes(userUnit)) {
		unit = 'lbs';
		isHigherUnit = true;
	}
	if (['gl', 'gal', 'Gal', 'GAL', 'Gallon', 'gallon'].includes(userUnit)) {
		unit = 'gal';
		isHigherUnit = true;
	}

	if (unit === '') {
		if (raiseError) {
			throw new Error(`Invalid unit (${userUnit})`);
		} else {
			return [null, null];
		}
	}

	return [unit, isHigherUnit];
}

export function addCommas(number, formatType = 'IN', withMonetaryUnit = false) {
	// eslint-disable-next-line no-restricted-globals
	if (isNaN(Number(number)))
		return Number(0).toLocaleString(`en-${formatType}`);
	const isString = typeof number === 'string';
	const formattedNumber = new Intl.NumberFormat(`en-${formatType}`).format(
		isString ? number : number?.toFixed(2)
	);
	if (withMonetaryUnit) {
		return `${getMonetaryUnit(formatType)} ${formattedNumber}`;
	}
	return formattedNumber;
}

export function addCommasOnly(number) {
	return new Intl.NumberFormat(`en-IN`).format(number);
}

// Separate function to format quantities with lakhs/crores
export const formatQuantityWithLakhsCrores = (value, options = {}) => {
	if (value == null || isNaN(value)) return options.placeholder || '0';

	const numValue = Number(value);
	const {
		includeCommas = true,
		showZeroDecimals = false,
		decimals = 2
	} = options;

	// For values in crores (1 crore = 1,00,00,000)
	if (numValue >= 10000000) {
		const crores = numValue / 10000000;
		const formatted = showZeroDecimals
			? crores.toFixed(decimals)
			: (crores % 1 === 0 ? crores.toFixed(0) : crores.toFixed(decimals));
		return `${formatted.replace(/\.00$/, '')}Cr`;
	}

	// For values in lakhs (1 lakh = 1,00,000)
	if (numValue >= 100000) {
		const lakhs = numValue / 100000;
		const formatted = showZeroDecimals
			? lakhs.toFixed(decimals)
			: (lakhs % 1 === 0 ? lakhs.toFixed(0) : lakhs.toFixed(decimals));
		return `${formatted.replace(/\.00$/, '')}L`;
	}

	// For values in thousands
	if (numValue >= 1000) {
		const thousands = numValue / 1000;
		const formatted = showZeroDecimals
			? thousands.toFixed(decimals)
			: (thousands % 1 === 0 ? thousands.toFixed(0) : thousands.toFixed(Math.min(1, decimals)));
		return `${formatted.replace(/\.00$/, '')}K`;
	}

	// For smaller numbers, format with commas if requested
	if (includeCommas && numValue >= 1000) {
		return numValue.toLocaleString('en-IN');
	}

	// Return as is for very small numbers
	return Math.round(numValue * 100) / 100;
};

export function getMonetaryUnit(formatType = 'IN') {
	if (formatType === 'US') {
		return '$';
	}
	return '\u20B9';
}

export function getLast12Months() {
	const months = [];
	const currentMonth = moment();

	for (let i = 0; i < 12; i++) {
		const newMonth = currentMonth.clone().subtract(i, 'months');
		const monthYear = newMonth.format('MMM YY');
		months.push(monthYear);
	}

	return months;
}

export function getLastFourYears() {
	const currentYear = new Date().getFullYear();
	const lastThreeYears = [];

	for (let i = 0; i < 3; i++) {
		lastThreeYears.push(currentYear - i);
	}

	return lastThreeYears;
}

export function convertWeight(weight, isUS) {
	if (isUS) {
		// Convert grams to ounces (1 gram = 0.03527396 ounces)
		const ounces = weight * 0.03527396;
		if (ounces >= 16) {
			// Convert ounces to pounds (1 pound = 16 ounces)
			return {
				value: ounces / 16,
				unit: 'lbs',
			};
		}
		return {
			value: ounces,
			unit: 'oz',
		};
	}
	// Convert grams to kilograms (1 gram = 0.001 kilograms)
	const kilograms = weight * 0.001;
	if (kilograms >= 1) {
		return {
			value: kilograms,
			unit: 'kg',
		};
	}
	return {
		value: weight,
		unit: 'g',
	};
}

export function formatNumber(conversionType = 'IN', number) {
	const formatOptions = {
		IN: [
			{
				divisor: 10000000,
				unit: 'cr',
			},
			{
				divisor: 100000,
				unit: 'lac',
			},
		],
		US: [
			{
				divisor: 1000000000,
				unit: 'bn',
			},
			{
				divisor: 1000000,
				unit: 'mn',
			},
		],
	};

	const options = formatOptions[conversionType];

	if (!options) {
		return 'Invalid conversion type';
	}

	const formatted = options.find(({ divisor }) => {
		return number >= divisor;
	});
	const formatValue = number / formatted?.divisor || 1;
	return formatted
		? `${formatValue?.toFixed(2)} ${formatted.unit}`
		: addCommas(number, conversionType);
}

export const modes = {
	PRODUCTION: 'AI-Inventory-In',
	INWARD: 'AI-GRN',
	OUTWARD: 'AI-Inventory-Out',
	CMS: 'AI-Cook',
	WASTAGE: 'AI-Wastage',
	DISPATCH: 'AI-Dispatch',
	PRODUCTION_PLAN: 'AI-Plan-Production',
	AUDIT: 'AI-Audit',
	BATCH_PRODUCTION: 'AI-Batch-Production',
};

export const options = {
	gram: [
		{
			displayName: 'Kg',
			value: 'kg',
		},
		{
			displayName: 'G',
			value: 'gram',
		},
	],
	g: [
		{
			displayName: 'Kg',
			value: 'kg',
		},
		{
			displayName: 'G',
			value: 'g',
		},
	],
	kg: [
		{
			displayName: 'Kg',
			value: 'kg',
		},
		{
			displayName: 'G',
			value: 'g',
		},
	],
	litre: [
		{
			displayName: 'L',
			value: 'L',
		},
		{
			displayName: 'mL',
			value: 'ml',
		},
	],
	ml: [
		{
			displayName: 'ltr',
			value: 'ltr',
		},
		{
			displayName: 'mL',
			value: 'ml',
		},
	],
	piece: [
		{
			displayName: 'Piece',
			value: 'piece',
		},
	],
	pc: [
		{
			displayName: 'Piece',
			value: 'piece',
		},
	],
	ltr: [
		{
			displayName: 'ltr',
			value: 'ltr',
		},
		{
			displayName: 'mL',
			value: 'ml',
		},
	],
	floz: [
		{
			displayName: 'Gal',
			value: 'gal',
		},
		{
			displayName: 'Fl oz',
			value: 'floz',
		},
	],
	gal: [
		{
			displayName: 'Gal',
			value: 'gal',
		},
		{
			displayName: 'Fl oz',
			value: 'floz',
		},
	],
	oz: [
		{
			displayName: 'Lb',
			value: 'lbs',
		},
		{
			displayName: 'Oz',
			value: 'oz',
		},
	],
	lbs: [
		{
			displayName: 'Lb',
			value: 'lbs',
		},
		{
			displayName: 'Oz',
			value: 'oz',
		},
	],
	lb: [
		{
			displayName: 'Lb',
			value: 'lb',
		},
		{
			displayName: 'Oz',
			value: 'oz',
		},
	],
};

// export const getHigherUnit = (unit) => {
// 	if(unit === 'kg' || unit === 'g'|| unit === 'gram'){
// 		return 'Kg';
// 	}
// 	if(unit === 'ml' || unit === 'ltr'){
// 		return 'Ltr';
// 	}
// };

const stateMap = {
	'01': 'Jammu and Kashmir',
	'02': 'Himachal Pradesh',
	'03': 'Punjab',
	'04': 'Chandigarh',
	'05': 'Uttarakhand',
	'06': 'Haryana',
	'07': 'Delhi',
	'08': 'Rajasthan',
	'09': 'Uttar Pradesh',
	10: 'Bihar',
	11: 'Sikkim',
	12: 'Arunachal Pradesh',
	13: 'Nagaland',
	14: 'Manipur',
	15: 'Mizoram',
	16: 'Tripura',
	17: 'Meghalaya',
	18: 'Assam',
	19: 'West Bengal',
	20: 'Jharkhand',
	21: 'Odisha',
	22: 'Chhattisgarh',
	23: 'Madhya Pradesh',
	24: 'Gujarat',
	25: 'Daman and Diu',
	26: 'Dadra and Nagar Haveli',
	27: 'Maharashtra',
	28: 'Andhra Pradesh',
	29: 'Karnataka',
	30: 'Goa',
	31: 'Lakshadweep',
	32: 'Kerala',
	33: 'Tamil Nadu',
	34: 'Puducherry',
	35: 'Andaman and Nicobar Islands',
	36: 'Telangana',
	37: 'Andhra Pradesh (New)',
	38: 'Telangana (New)',
	97: 'Other Territory',
	98: 'Other Territory',
	99: 'Other Territory',
};
export function getStateFromGSTIN(gstin) {
	const stateCode = gstin?.substr(0, 2);
	return stateMap[stateCode] || 'Unknown';
}
export function getStateCodeFromGSTIN(gstin) {
	return Number(gstin?.substr(0, 2));
}

export const getTaxFromStr = (tt) => {
	let num = 0;
	let taxStr = tt;
	if (!taxStr) return num;
	if (taxStr?.includes?.('%')) {
		taxStr = taxStr?.replace('%', '');
		if (!Number.isNaN(taxStr)) {
			num = Number(taxStr);
		}
	}
	return num;
};

export function downloadCSV(csv, filename) {
	// CSV file. Prepend a UTF-8 BOM so Excel detects UTF-8 instead of falling
	// back to the Windows ANSI codepage — otherwise multi-byte chars (e.g. a
	// non-breaking space) render as mojibake like "Â ".
	const BOM = String.fromCharCode(0xfeff);
	const csvFile = new Blob([BOM, csv], {
		type: 'text/csv;charset=utf-8;',
	});

	// Download link
	const downloadLink = document.createElement('a');

	// File name
	downloadLink.download = filename;

	// Create a link to the file
	downloadLink.href = window.URL.createObjectURL(csvFile);

	// Hide download link
	downloadLink.style.display = 'none';

	// Add the link to DOM
	document.body.appendChild(downloadLink);

	// Click download link
	downloadLink.click();
}

export function downloadWithFileType(stringData, filename, fileType) {
	// CSV file
	const csvFile = new Blob([stringData], {
		type: fileType,
	});

	// Download link
	const downloadLink = document.createElement('a');

	// File name
	downloadLink.download = filename;

	// Create a link to the file
	downloadLink.href = window.URL.createObjectURL(csvFile);

	// Hide download link
	downloadLink.style.display = 'none';

	// Add the link to DOM
	document.body.appendChild(downloadLink);

	// Click download link
	downloadLink.click();
}

export const paymentModes = [
	'Happay',
	'Razorpay',
	'Enkash',
	'Paid By Employee',
];

export function addDays(
	dateStr,
	noOfDays,
	dateFormat = 'YYYY-MM-DD HH:mm:ss',
	returnFormat = 'YYYY-MM-DD HH:mm:ss'
) {
	// Parse the input date string using Moment.js
	const date = moment(dateStr, dateFormat);
	// Add the specified number of days
	date.add(noOfDays, 'days');

	// Format the new date back to a string
	const newDateStr = date.format(returnFormat);

	return newDateStr;
}
function daysRemainingInCurrentMonth() {
	const today = new Date();
	const lastDayOfCurrentMonth = new Date(
		today.getFullYear(),
		today.getMonth() + 1,
		0
	);
	const timeDiff = lastDayOfCurrentMonth - today;
	return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
}

function daysRemainingUntilEndOfNextMonth() {
	const today = new Date();
	const lastDayOfNextMonth = new Date(
		today.getFullYear(),
		today.getMonth() + 2,
		0
	);
	const timeDiff = lastDayOfNextMonth - today;
	return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
}

export const paymentTermsList = [
	{
		value: 'Net 15',
		noOfDays: 15,
	},
	{
		value: 'Net 30',
		noOfDays: 30,
	},
	{
		value: 'Net 45',
		noOfDays: 45,
	},
	{
		value: 'Net 60',
		noOfDays: 60,
	},
	{
		value: 'Due end of the month',
		noOfDays: daysRemainingInCurrentMonth(),
	},
	{
		value: 'Due end of next month',
		noOfDays: daysRemainingUntilEndOfNextMonth(),
	},
	{
		value: 'Due on receipt',
		noOfDays: 0,
	},
	{
		value: 'Advance Payment',
		noOfDays: 0,
	},
];

export const findPaymentTerm = (paymentTerm) => {
	const currPaymentTerm = paymentTermsList?.find((ele) => {
		return ele?.value === paymentTerm;
	});
	return currPaymentTerm ?? {};
};

export function isDateWithinRange(date, range) {
	if (!range) return true;
	const fromDate = moment(range?.from).startOf('day');
	const toDate = moment(range?.to).startOf('day');
	const dateToCheck = moment(date).startOf('day');

	// Check if date is within range [fromDate, toDate]
	return (
		dateToCheck.isSameOrAfter(fromDate) &&
		dateToCheck.isSameOrBefore(toDate)
	);
}

export function isTimeLessThanCurrentTime(
	endTimeString,
	timeFormat = 'hh:mm A'
) {
	const currTime = moment();
	const endTime = moment(endTimeString, timeFormat);
	endTime.set({
		year: currTime.year(),
		month: currTime.month(),
		date: currTime.date(),
	});
	return endTime.isBefore(currTime);
}

export const billSubTypes = ['EXPENSE', 'UTILITIES', 'GRN', 'CAPEX'];

export function getRandomNeonDarkColor() {
	// Generate two random values between 0 and 100 for darkness
	const randomValue1 = Math.floor(Math.random() * 101);
	const randomValue2 = Math.floor(Math.random() * 101);

	// Set one channel to a high value between 150 and 255 for a neon effect
	const neonValue = Math.floor(Math.random() * 106) + 150;

	// Randomly decide which channel to assign the neon value
	const colorChannels = [
		[neonValue, randomValue1, randomValue2],
		[randomValue1, neonValue, randomValue2],
		[randomValue1, randomValue2, neonValue],
	];

	// Randomly pick one of the neon dark combinations
	const [r, g, b] = colorChannels[Math.floor(Math.random() * 3)];

	return `rgb(${r}, ${g}, ${b})`;
}

export const groupTypeFilterList = [
	{
		value: 'periodWise',
		label: 'Time',
		currentSelection: '',
		selection: {
			category: {
				value: null,
				label: 'Category',
			},
			subCategory: {
				value: null,
				label: 'Sub Category',
			},
		},
	},
	{
		value: 'productGroupWise',
		label: 'Product',
		currentSelection: 'brand',
		selection: {
			category: {
				value: null,
				label: 'Category',
			},
			subCategory: {
				value: null,
				label: 'Sub Category',
			},
		},
	},
	{
		value: 'geographyWise',
		label: 'Geography',
		currentSelection: 'brand',
		selection: {
			region: {
				value: null,
				label: 'Region',
			},
			city: {
				value: null,
				label: 'City',
			},
		},
	},
];

export const handleResponseStreamDownload = async (
	response,
	downloadFileName = 'test.csv'
) => {
	if (response.ok) {
		// let fileName = downloadFileName;
		// response?.headers?.forEach((ele) => { console.log(ele); });
		const blob = await response?.blob();
		const downloadUrl = window.URL.createObjectURL(blob);
		const hiddenElement = document.createElement('a');
		hiddenElement.href = downloadUrl;
		// if (getFileNameFromHeader) {
		// 	const contentDisposition = response?.headers?.get?.('content-disposition');
		// 	console.log(contentDisposition);
		// 	if (contentDisposition?.includes?.('filename=')) {
		// 		// eslint-disable-next-line prefer-destructuring
		// 		fileName = contentDisposition.split('filename=')[1];
		// 	}
		// }

		hiddenElement.download = downloadFileName;
		document.body.appendChild(hiddenElement);
		hiddenElement.click();
		// Defer cleanup: the browser reads the blob URL asynchronously after the
		// click, so revoking it synchronously truncates/corrupts large downloads
		// (small files finish reading in time, large ones get cut off).
		setTimeout(() => {
			window.URL.revokeObjectURL(downloadUrl);
			if (hiddenElement.parentNode) {
				document.body.removeChild(hiddenElement);
			}
		}, 60000);
	} else {
		return null;
	}
	return null;
};

export const higherUnits = {
	ml: {
		higherUnit: 'ltr',
		divideBy: 1000,
	},
	gram: {
		higherUnit: 'kg',
		divideBy: 1000,
	},
	g: {
		higherUnit: 'kg',
		divideBy: 1000,
	},
	floz: {
		higherUnit: 'gal',
		divideBy: 128,
	},
	oz: {
		higherUnit: 'lb',
		divideBy: 16,
	},
	count: {
		higherUnit: 'pc',
		divideBy: 1,
	},
};
export const convertToHigherUnit = (unit, value) => {
	return {
		unit: higherUnits?.[unit]?.higherUnit ?? unit,
		value: value ? Math.round(100 * value / higherUnits?.[unit]?.divideBy) / 100 : 0,
	};
};

export const skuTypesList = [
	'PRODUCT',
	'INTERMEDIATE',
	'INGREDIENT',
	'UNPACKED_PRODUCT',
	'PACKAGING',
	'OTHER',
];

export const skuTypesListWithId = [
	{
		id: 0,
		title: 'ALL',
		displayName: 'ALL',
	},
	{
		id: 1,
		title: 'Product',
		displayName: 'Product',
	},
	{
		id: 2,
		title: 'Intermediate',
		displayName: 'Intermediate',
	},
	{
		id: 3,
		title: 'Ingredient',
		displayName: 'Ingredient',
	},
	{
		id: 4,
		title: 'Packaging',
		displayName: 'Packaging',
	},
	{
		id: 5,
		title: 'Other',
		displayName: 'Other',
	},
	{
		id: 6,
		title: 'UNPACKED_PRODUCT',
		displayName: 'Unpacked Product',
	},
];

export const processTypes = [
	{
		id: 'STORAGE',
		name: 'STORAGE',
	},
	{
		id: 'OPERATION',
		name: 'OPERATION',
	},
];

export const renderComponentToHtml = (Component, props) => {
	const element = React.createElement(Component, props);
	const html = ReactDOMServer.renderToStaticMarkup(element);
	return html;
};

export const handleOrderStatus = (status) => {
	if (status === 'TRANSIT') {
		return 'IN TRANSIT';
	}
	if (status === 'DISPATCH') {
		return 'PENDING DISPATCH';
	}
	if (status === 'UNLOADING') {
		return 'UNLOADING STARTED';
	}
	if (status === 'VERIFICATION') {
		return 'PENDING VERIFICATION';
	}
	return status;
};

export const shipmentStatus = (status) => {
	if (status === 'TRANSIT') {
		return 'IN TRANSIT';
	}
	if (status === 'FULFILLED') {
		return 'RECEIVED';
	}
	if (status === 'PACKAGING') {
		return 'PENDING';
	}
	if (status === 'DISPATCH') {
		return 'PENDING DISPATCH';
	}
	if (status === 'UNLOADING') {
		return 'UNLOADING';
	}
	if (status === 'VERIFICATION') {
		return 'VERIFICATION';
	}
	return status;
};

export const supplyChainFeilds = [
	{
		id: 1,
		name: 'SOURCING',
		value: ['WAREHOUSE_INGREDIENT', 'WAREHOUSE', 'WAREHOUSE_PRODUCT'],
	},
	{
		id: 2,
		name: 'PRODUCTION',
		value: 'BASE',
	},
	{
		id: 3,
		name: 'DISTRIBUTION',
		value: 'RETAIL',
	},
	{
		id: 4,
		name: 'TRANSIT',
		value: 'transit',
	},
];

export const getBase64FromFileBlob = (file, cb) => {
	const reader = new FileReader();
	reader.readAsDataURL(file);
	reader.onload = function () {
		cb(reader.result);
	};
	reader.onerror = function (error) {
		console.log('Error: ', error);
	};
};

export function parseCSV(str) {
	const arr = [];
	let quote = false; // 'true' means we're inside a quoted field

	// Iterate over each character, keep track of current row and column (of the returned array)
	for (let row = 0, col = 0, c = 0; c < str.length; c++) {
		const cc = str[c];
		const nc = str[c + 1]; // Current character, next character
		arr[row] = arr[row] || []; // Create a new row if necessary
		arr[row][col] = arr[row][col] || ''; // Create a new column (start with empty string) if necessary

		// If the current character is a quotation mark, and we're inside a
		// quoted field, and the next character is also a quotation mark,
		// add a quotation mark to the current column and skip the next character
		if (cc === '"' && quote && nc === '"') {
			arr[row][col] += cc;
			c++;
			continue;
		}

		// If it's just one quotation mark, begin/end quoted field
		if (cc === '"') {
			quote = !quote;
			continue;
		}

		// If it's a comma and we're not in a quoted field, move on to the next column
		if (cc === ',' && !quote) {
			++col;
			continue;
		}

		// If it's a newline (CRLF) and we're not in a quoted field, skip the next character
		// and move on to the next row and move to column 0 of that new row
		if (cc === '\r' && nc === '\n' && !quote) {
			row++;
			col = 0;
			c++;
			continue;
		}

		// If it's a newline (LF or CR) and we're not in a quoted field,
		// move on to the next row and move to column 0 of that new row
		if (cc === '\n' && !quote) {
			row++;
			col = 0;
			continue;
		}
		if (cc === '\r' && !quote) {
			row++;
			col = 0;
			continue;
		}

		// Otherwise, append the current character to the current column
		arr[row][col] += cc;
	}
	return arr;
}

export const csvArrayToObject = (csvArray) => {
	const objects = [];
	const headers = csvArray[0];
	csvArray.forEach((item, index) => {
		if (index === 0) {
			return;
		}
		const object = {};
		item.forEach((e, i) => {
			object[headers[i]] = e;
		});
		objects.push(object);
	});
	return objects;
};

export const cellColor = (value) => {
	let number;
	if (typeof value === 'object') {
		number =
			(parseFloat(value?.fullfilledQty) / value?.orderQtyValue) * 100;
	} else {
		number = value;
	}
	const val = parseFloat(number);
	if (val === 0) {
		return '#000000';
	}
	if (val >= 95 && val <= 105) {
		return '#006400';
	}
	return '#8B0000';
};

export const cellColor2 = (percentage) => {

	const val = parseFloat(percentage);
	let color = '#8B0000'; // Red	
	if (val === 0) {
		color = '#000000'; // Black
	}
	if (val >= 95 && val <= 105) {
		color = '#006400'; // Green
	}
	return { color, value: val };
};

export const calculateShelfLife = (mfgDate, expDate) => {
	if (!mfgDate || !expDate) return 0;
	const mfgTime = new Date(mfgDate).getTime();
	const expTime = new Date(expDate).getTime();
	const currentTime = new Date().getTime();

	if (isNaN(mfgTime) || isNaN(expTime)) {
		console.error('Invalid date format:', mfgDate, expDate);
		return 0;
	}

	if (currentTime >= expTime) return 0;

	const totalShelfLife = expTime - mfgTime;
	const remainingShelfLife = expTime - currentTime;

	const percentage = (remainingShelfLife / totalShelfLife) * 100;
	return Math.max(0, Math.round(percentage));
};

export const formatDate = (date) => {
	const d = new Date(date);
	return `${d.getFullYear()}-${(d.getMonth() + 1)
		.toString()
		.padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
};

export const handleExportData = (data, COLMAP, name, filters) => {
	const headers = name === 'Shift Managment' ? Object.keys(COLMAP).filter(key => key !== 'Cancel') : Object.keys(COLMAP);
	let filtersObj = {};
	if (filters?.dateRange) {
		filtersObj.dateRangeFilter = filters?.dateRange;
	}

	const rows = data?.map((item) => {
		return headers.map((header) => {
			if (name === 'PaymentsMade') {
				const value = item[COLMAP[header]];
				if (header === 'Bills Paid') {
					return Object?.keys(value?.associatedPayments?.onBills ?? {})?.length;
				}
				return value || '-';
			}
			const value = item[COLMAP[header]];

			// Format dates if needed
			if (header.includes('At')) {
				return format(new Date(value), 'yyyy-MM-dd HH:mm:ss');
			}
			return `"${value}"` || '-';
		});
	});

	// Combine headers and rows
	const csvData = [headers, ...rows];

	// Generate filename with timestamp
	const filename = getFileName(filtersObj);

	// Download CSV
	const csvContent = csvData.map((row) => row.join(',')).join('\n');
	const csvFile = new Blob([csvContent], { type: 'text/csv' });

	// Create download link
	const downloadLink = document.createElement('a');
	downloadLink.download = filename;
	downloadLink.href = window.URL.createObjectURL(csvFile);
	downloadLink.style.display = 'none';

	// Add to DOM, trigger click, then clean up
	document.body.appendChild(downloadLink);
	downloadLink.click();
	window.URL.revokeObjectURL(downloadLink.href);
	document.body.removeChild(downloadLink);
};

export const sanitizeCell = (value) => {
	if (value === null || value === undefined) return '-';
	const str = String(value);

	// Remove commas
	const noCommas = str.split(',').join('');

	// Remove non-ASCII characters (char codes > 127)
	const asciiOnly = [...noCommas]
		.filter(char => char.charCodeAt(0) <= 127)
		.join('');

	return asciiOnly;
};

export const filtersInfoChip = (filtersInfo = {}, filters = {}) => {
	const enhancedFiltersInfo = { ...filtersInfo };
	// Add filter type if it exists in filters but not in filtersInfo
	if (filters.filterType && !filtersInfo.filterType) {
		enhancedFiltersInfo.filterType = {
			text: 'Filter Type',
			show: true,
		};
	}
	return (
		<div className="flex flex-wrap gap-2 w-full items-center mb-3 mt-1 px-2 justify-end">
			{Object.entries(enhancedFiltersInfo)
				.filter(([key, value]) => value.show === true && key !== 'header' && !value.hideChip)
				.map(([key, value]) => {
					const capitalizeFirstLetter = (string) => {
						return string.charAt(0).toUpperCase() + string.slice(1);
					};

					// Get display label for the filter type
					const filterLabel = value?.text || capitalizeFirstLetter(key);
					// Get the current filter value from the active filters object
					let filterValue = '';
					if (key === 'filteredStore' && filters?.store?.id) {
						filterValue = filters.store?.name;
					} else if (key === 'filteredStore' && filters?.filterMultiStore?.id) {
						filterValue = filters?.filterMultiStore?.name?.join(', ');
					} else if (key === 'store' && filters?.multiStore?.id) {
						filterValue = filters?.multiStore?.name?.join(', ');
					} else if (key === 'dateRange' && filters?.dateRange?.active) {
						filterValue = `${moment(filters.dateRange.from).format('DD-MM-YYYY')} to ${moment(filters.dateRange.to).format('DD-MM-YYYY')}`;
					} else if (key === 'dateRangeOnly' && filters?.dateRange) {
						filterValue = `${moment(filters.dateRange.from).format('DD-MM-YYYY')} to ${moment(filters.dateRange.to).format('DD-MM-YYYY')}`
					} else if (key === 'dateRangeWithType' && filters?.dateRange) {
						filterValue = `${moment(filters.dateRange.from).format('DD-MM-YYYY')} to ${moment(filters.dateRange.to).format('DD-MM-YYYY')}`;
					} else if (key === 'imagesType' && filters?.imagesType) {
						filterValue = filters.imagesType;
					} else if (key === 'pageLimit' && (filters?.page || filters?.pageLimit)) {
						filterValue = filters.page || filters?.pageLimit;
					} else if (key === 'processType' && filters?.processTypes) {
						filterValue = filters.processTypes?.name;
					} else if (key === 'fromProcess' && (Array.isArray(filters?.fromProcess?.id) ? filters?.fromProcess?.id?.length > 0 : filters?.fromProcess?.id)) {
						filterValue = Array.isArray(filters?.fromProcess?.name) ? filters?.fromProcess?.name?.join(', ') : filters?.fromProcess?.name;
					} else if (key === 'toProcess' && (Array.isArray(filters?.toProcess?.id) ? filters?.toProcess?.id?.length > 0 : filters?.toProcess?.id)) {
						filterValue = Array.isArray(filters?.toProcess?.name) ? filters?.toProcess?.name?.join(', ') : filters?.toProcess?.name;
					} else if (key === 'type' && Array.isArray(filters?.type)) {
						filterValue = filters.type.join(', ');
					} else if (key === 'type' && (filters?.type || filters?.typeName)) {
						if (filters?.typeName) {
							filterValue = filters.typeName;
						} else {
							filterValue = filters.type;
						}
					} else if (key === 'status' && Array.isArray(filters?.status)) {
						filterValue = filters.status.join(', ');
					} else if (key === 'status' && filters?.status) {
						filterValue = filters.status;
					} else if (key === 'vendor' && filters?.vendors?.id?.length > 0) {
						filterValue = filters.vendors?.name?.join(', ');
					} else if (key === 'vendor' && filters?.vendor?.id) {
						filterValue = filters.vendor?.name;
					} else if (key === 'buyer' && filters?.buyer?.id?.length > 0) {
						filterValue = filters.buyer?.name?.join(', ');
					} else if (key === 'timeType' && filters?.timeType && filters?.dateRange?.active) {
						filterValue = filters?.timeType?.label;
					} else if (key === 'customExclusiveFilters' && filters?.customExclusiveFilters?.id?.length > 0) {
						filterValue = Array.isArray(filters?.customExclusiveFilters?.name) ? filters?.customExclusiveFilters?.name?.join(', ') : filters?.customExclusiveFilters?.name
					} else if (key === 'filterType' && filters?.filterType) {
						filterValue = filters.filterType;
					} else if (key === 'store' && filters?.store?.id) {
						filterValue = filters.store?.name;
					} else if (key === 'deliverTo' && filters?.deliverTo?.id) {
						filterValue = filters.deliverTo?.name;
					} else if (key === 'paymentStatus' && filters?.paymentStatus) {
						filterValue = filters.paymentStatus;
					} else if (key === 'paymentType' && filters?.paymentType) {
						filterValue = filters.paymentType;
					} else if (key === 'productionPlan' && filters?.productionPlan?.id?.length > 0) {
						filterValue = filters.productionPlan?.name?.join(', ');
					} else if (key === 'identificationType' && filters?.identification) {
						filterValue = filters.identification;
					} else if (key === 'brand' && filters?.brand?.id) {
						filterValue = filters.brand?.name;
					} else if (key === 'product' && filters?.products) {
						filterValue = filters.products?.name?.join(', ');
					} else if (key === 'regions' && filters?.region) {
						filterValue = filters.region;
					} else if (key === 'group' && filters?.group) {
						filterValue = filters.group?.name;
					} else if (key === 'productExclusive' && filters?.productExclusive) {
						filterValue = filters.productExclusive?.name;
					} else if (key === 'ingredient' && filters?.ingredient) {
						filterValue = filters.ingredient?.name;
					} else if (key === 'dateOnly' && filters?.dateOnly) {
						filterValue = moment(filters.dateOnly?.date).format('DD-MM-YYYY');
					} else if (key === 'productCategory' && filters?.productCategories) {
						filterValue = filters.productCategories?.name?.join(', ');
					} else if (key === 'product' && filters?.product?.id) {
						filterValue = filters.product?.name;
					} else if (key === 'productCategory' && filters?.productCategory?.id) {
						filterValue = filters.productCategory?.name;
					} else if (key === 'featureType' && filters?.featureType) {
						filterValue = filters.featureType;
					} else if (key === 'egaPercentage' && filters?.egaPercentage) {
						filterValue = filters.egaPercentage + '%';
					} else if (key === 'confidence' && filters?.conf) {
						filterValue = (filters.conf?.minConf ?? '') + ' - ' + (filters.conf?.maxConf ?? '');
					} else if (key === 'deliverFrom' && filters?.deliverFrom?.id) {
						filterValue = filters.deliverFrom?.name;
					} else if (key === 'shift' && filters?.shift?.id) {
						filterValue = filters?.shift?.name;
					} else if (key === 'skuType' && filters?.skuType) {
						filterValue = filters?.skuType;
					} else if (key === 'productWithVariants' && filters?.productWithVariant) {
						filterValue = filters?.productWithVariant?.labels.toString();
					} else if (key === 'kitchenBaseStore' && filters?.fromPodFilter?.id) {
						filterValue = filters?.fromPodFilter?.name;
					} else if (key === 'pods' && filters?.toPodFilter?.id) {
						filterValue = filters?.toPodFilter?.name;
					} else if (key === 'orderType' && filters?.orderType) {
						filterValue = filters?.orderType;
					} else if (key === 'mealType' && filters?.mealType) {
						filterValue = filters?.mealType;
					} else if (key === 'allProcessType' && filters?.allProcessTypeMulti?.id?.length > 0) {
						filterValue = filters?.allProcessTypeMulti?.name?.join(',');
					} else if (key === 'skuType' && filters?.skuTypeMulti?.length > 0) {
						filterValue = filters?.skuTypeMulti?.join(',');
					} else if (key === 'duplicate' && filters?.duplicate) {
						filterValue = filters?.duplicate;
					} else if (key === 'validation' && filters?.validation) {
						filterValue = filters?.validation;
					} else if (key === 'identified' && filters?.identified) {
						filterValue = filters?.identified;
					} else if (key === 'feature' && filters?.feature) {
						filterValue = filters?.feature;
					} else if (key === 'tab' && filters?.tab) {
						filterValue = filters?.tab;
					} else if (key === 'longTermPlan' && filters?.longTermPlan) {
						if (Array.isArray(filters?.longTermPlan)) {
							filterValue = filters?.longTermPlan?.map((item) => item?.name)?.join(',');
						} else {
							filterValue = filters?.longTermPlan?.name;
						}
					}
					return filterValue ? (
						<Chip
							key={key}
							label={
								<span className="flex items-center">
									<span className="font-medium">{filterLabel}: </span>
									<span className="ml-1 font-bold">{filterValue === -999 ? 'All' : filterValue}</span>
								</span>
							}
							className='bg-slate-100 text-gray-700 hover:bg-slate-200 transition-colors duration-200 shadow-sm border border-gray-200 rounded-full'
						/>
					) : null;
				})
			}
		</div>
	);
};

export const isSalesUnitConsumptionLogicTrue = (product) => {
	if (
		product?.unit == 'count' &&
		product?.salesUnit?.length > 0 &&
		product?.unit != product?.salesUnit
	) {
		return true;
	}
	return false;
};

// An order line counted in pieces but sold by the gram: Console 2 stamps `salesUnit`, `subUnit`
// and `minWeight` on it (inventory.stampSalesUnitWeights), and it reads as min weight x pax
// with the pax beneath.
export const isSalesWeightLine = (item) =>
	item?.unit === 'count' &&
	item?.salesUnit === 'gram' &&
	Number(item?.minWeight) > 0;

// The product's sub unit (Pax, Plate…), or its own unit when it names none ("pcs" for count).
const getSalesWeightSubUnit = (item) =>
	item?.subUnit || getHigherUnitName(item?.unit) || item?.unit;

const getSalesWeightGrams = (item, qty) =>
	(Number(qty) || 0) * Number(item?.minWeight);

/** `qty` pieces of a sales-weight line as "1.200 kg" over "4 Pax"; `null` for any other line. */
export const renderSalesWeightQty = (item, qty) => {
	if (!isSalesWeightLine(item)) return null;
	const grams = getSalesWeightGrams(item, qty);
	return (
		<span className='inline-flex flex-col leading-tight'>
			<span>{`${getUnitConvertedQuantity(grams, 'gram', true, true)} ${getUnitConvertedUnit(grams, 'gram')}`}</span>
			<span className='text-xs text-gray-500'>{`${Number(qty) || 0} ${getSalesWeightSubUnit(item)}`}</span>
		</span>
	);
};

/** The unit cell of a sales-weight line: the ordered weight's unit over its sub unit; `null` otherwise. */
export const renderSalesWeightUnit = (item) => {
	if (!isSalesWeightLine(item)) return null;
	return (
		<span className='inline-flex flex-col leading-tight'>
			<span>{getUnitConvertedUnit(getSalesWeightGrams(item, item?.qty), 'gram')}</span>
			<span className='text-xs text-gray-500'>{getSalesWeightSubUnit(item)}</span>
		</span>
	);
};

export const alterProductForSalesUnitConsumptionLogic = (
	product,
	type = 'recipe'
) => {
	if (isSalesUnitConsumptionLogicTrue(product)) {
		if (type == 'recipe') {
			const varKeys = Object?.keys?.(product?.ProductVariant);
			const leastKey = varKeys?.reduce?.((a, b) => (a < b ? a : b));
			return {
				...product,
				salesConsumptionUnit: true,
				unit: product?.salesUnit,
				ProductVariant: {
					[leastKey]: {
						...product?.ProductVariant[leastKey],
						unit: product?.salesUnit,
						displayName: '-*-',
						salesConsumptionUnit: true,
					},
				},
			};
		} else if (type == 'leftOver') {
			const varKeys = product?.variants?.map((variant) => variant?.id);
			const leastKey = varKeys?.reduce?.((a, b) => (a < b ? a : b), varKeys[0]);
			const havingLeastId = product?.variants?.find(
				(variant) => variant?.id == leastKey
			);
			return {
				...product,
				salesConsumptionUnit: true,
				unit: product?.salesUnit,
				variants: [
					{
						...havingLeastId,
						unit: product?.salesUnit,
						displayName: '-*-',
						salesConsumptionUnit: true,
					},
				],
			};
		}
	}
	return product;
};

export const getUnitOnProductPageFromFields = (obj, unit1Key) => {
	return (
		obj?.fields?.[unit1Key]?.find(
			(productUnitObject) => productUnitObject.isApplied
		)?.id || ''
	);
};

export const getActionColumn = (BASE_COLUMNS, ADDITIONAL_COLUMNS, level, rearrangeColumns = false, desiredOrder = [], pageName = '') => {
	if (rearrangeColumns) {
		const ALL_COLUMNS = [...BASE_COLUMNS, ...ADDITIONAL_COLUMNS];
		const FINAL_COLUMNS = desiredOrder
			.map(title => ALL_COLUMNS.find(col => col.title === title))
			.filter(Boolean);
		return level !== 1 ? [...FINAL_COLUMNS] : [...BASE_COLUMNS];
	}
	if (pageName === 'My Audits') {
		return level > 2 ? [...BASE_COLUMNS, ...ADDITIONAL_COLUMNS] : [...BASE_COLUMNS];
	}
	return level !== 1 ? [...BASE_COLUMNS, ...ADDITIONAL_COLUMNS] : [...BASE_COLUMNS];
};

export const handleImagePreview = (imageUrl) => {
	const previewContainer = document.createElement('div');
	previewContainer.className = 'imagePreview';
	previewContainer.style.position = 'fixed';
	previewContainer.style.top = '0';
	previewContainer.style.left = '0';
	previewContainer.style.width = '100%';
	previewContainer.style.height = '100%';
	previewContainer.style.backgroundColor = 'rgba(0,0,0,0.8)';
	previewContainer.style.display = 'flex';
	previewContainer.style.justifyContent = 'center';
	previewContainer.style.alignItems = 'center';
	previewContainer.style.zIndex = '99999';

	const previewImage = document.createElement('img');
	previewImage.src = imageUrl;
	previewImage.style.maxHeight = '80%';
	previewImage.style.maxWidth = '80%';

	previewContainer.addEventListener('click', () => {
		document.body.removeChild(previewContainer);
	});

	previewContainer.appendChild(previewImage);
	document.body.appendChild(previewContainer);
};

export const getBrowserStorageSpace = (isSessionStorage = false) => {
	let _lsTotal = 0;
	let _xLen;
	let _x;
	const storage = isSessionStorage ? sessionStorage : localStorage;
	for (_x in storage) {
		if (!storage.hasOwnProperty(_x)) {
			continue;
		}
		_xLen = (storage[_x].length + _x.length) * 2;
		_lsTotal += _xLen;
	}
	return _lsTotal;
};

export const getPODeltas = (po) => {
	if (po?.orderStatus !== 'CLOSED') return <></>;

	const shortSupplyItems = po?.items
		?.filter(
			(item) => (item?.fulfilled ?? 0) > (item?.storeFulfilled ?? 0)
		)
		?.reduce((acc, item) => {
			const qty =
				(item?.fulfilled ?? 0) - (item?.storeFulfilled ?? 0);
			return (
				acc +
				qty * item?.productCost * (1 + item.taxPercentage / 100)
			);
		}, 0);
	const extraSupplyItems = po?.items
		?.filter(
			(item) => (item?.fulfilled ?? 0) < (item?.storeFulfilled ?? 0)
		)
		?.reduce((acc, item) => {
			const qty =
				(item?.storeFulfilled ?? 0) - (item?.fulfilled ?? 0);
			return (
				acc +
				qty * item?.productCost * (1 + item.taxPercentage / 100)
			);
		}, 0);

	return (
		<div>
			{shortSupplyItems > 0 && (
				<div className='text-red-700 text-[10px]'>
					Loss in transit ₹
					{shortSupplyItems >= 0
						? addCommas(shortSupplyItems)
						: '-'}
				</div>
			)}
			{extraSupplyItems > 0 && (
				<div className='text-red-800 text-[10px]'>
					Extra supply ₹
					{extraSupplyItems >= 0
						? addCommas(extraSupplyItems)
						: '-'}
				</div>
			)}
		</div>
	);
};

export const baseUnits = ['gram', 'gm', 'g', 'oz', 'floz', 'ml'];

export const canDataBeStoredInBrowserStorage = (stringData) => {
	const storageSpace = getBrowserStorageSpace();
	const dataLength = stringData.length;
	const dataSize = (dataLength * 32);
	return storageSpace + dataSize < 5000000;
}
export const useProductData = (dispatch) => {
	dispatch(
		formActions.gateway({
			entity: 'ALL_PRODUCTS',
			req: {
				params: {
					id: '',
					skuType: '',
					combo: true,
					variants: true,
				},
			},
			method: 'LIST',
		})
	);
};

export const fetchList = (dispatch, entity = '') => {
	switch (entity) {
		case 'shifts':
			dispatch(analyticsAction?.getShifts());
			break;
		default:
			break;
	}
}

export const variantMap = (products) => {
	return products.reduce((acc, product) => {
		product.variants?.forEach((variant) => {
			acc[Number(variant?.id)] = {
				categoryName: product.categoryName,
				subCategoryName: product.subCategoryName,
				clientVariantId: variant.clientVariantId,
			};
		});
		return acc;
	}, {});
};

const statusStyles = {
	DISPATCH: 'rgba(255, 217, 0, 0.5)',      // yellow
	TRANSIT: 'rgba(10, 17, 17, 0.5)',
	'IN TRANSIT': 'rgba(255, 237, 213, 1)',
	'PENDING DISPATCH': 'rgba(254, 249, 195, 1)',
	UNLOADING: 'rgba(255, 208, 0, 0.5)',     // orange-ish
	VERIFICATION: 'rgba(30, 255, 0, 0.25)',  // green
	FULFILLED: 'rgba(0, 128, 0, 0.5)',       // green
	CLOSED: '#bbf7d0',          // green
	CANCELLED: '#fecaca',       // red
	ABANDONED: '#64748b',
	UNLOADING: 'rgba(214, 211, 209, 1)',
	VERIFICATION: 'rgba(191, 219, 254, 1)',
	RECEIVED: 'rgba(187, 247, 208, 1)',
	ABANDONED: 'rgba(71, 85, 105, 1)',
};

const textColors = {
	'IN TRANSIT': '#EA580C',
	DISPATCH: '#b38600',
	'PENDING DISPATCH': '#CA8A04',
	TRANSIT: '#2563EB',
	UNLOADING: '#b37700',
	VERIFICATION: '#1b7300',
	FULFILLED: '#006600',
	CLOSED: '#166534',
	CANCELLED: '#991b1b',
	ABANDONED: '#cbd5e1',
	UNLOADING: '#57534E',
	VERIFICATION: '#2563EB',
	RECEIVED: '#16A34A',
	ABANDONED: '#94A3B8',
};

export function getStatusStyle(status) {
	return {
		background: statusStyles[status] || 'transparent',
		color: textColors[status] || '#000',
		padding: '6px 6px',
		borderRadius: '4px',
		fontSize: '12px',
		textAlign: 'center',
		textWrap: 'nowrap',
	};
};
export const formatDateOneLiner = (date) => {
	const d = new Date(date);
	const day = d.getDate();
	const ord = day + (['st', 'nd', 'rd'][((day + 90) % 100 - 10) % 10 - 1] || 'th');
	return `${ord} ${d.toLocaleDateString('en-US', { month: 'long' })} ${d.getFullYear().toString().slice(-2)}`;
};
export const truncateText = (text, maxLength = 15) => {
	if (!text) return '-';
	return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
};

export const getOrderType = (type) => {
	const orderType = {
		1: 'ORDER',
		2: 'CMS',
		3: 'CAPEX',
		4: 'SERVICE'
	}
	return orderType[type]
}

export const disableProductionPlanBtn = (date) => {
	const todayDate = new Date();
	const dateObj = new Date(date);
	todayDate.setHours(0, 0, 0, 0);
	dateObj.setHours(0, 0, 0, 0);
	return dateObj < todayDate;
};

export const isGstinDifferent = (gstin1, gstin2) => {
	const normalize = (gstin) => {
		if (!gstin) return '';
		return gstin.toString().trim().toUpperCase();
	};

	const g1 = normalize(gstin1);
	const g2 = normalize(gstin2);
	return g1 && g2 && g1 !== g2;
};

export const serializeVisibilityForAmountCaption = (data, key) => {
	let amount = data?.[key]?.value;
	let percentage = null;
	if ('percentageValue' in data?.[key]) {
		percentage = data?.[key]?.percentageValue;
	}
	if (data?.[key]?.type === 'currency') {
		amount = `\u20B9${formatNumber(
			'IN',
			data[key]?.value
		)}`;
	}
	if (data?.[key]?.type === 'weight') {
		amount = `${data[key]?.value} `;
	}
	return {
		caption: data[key].label,
		amount,
		label: data[key].label,
		subText: data?.[key]?.subText,
		subText2: data?.[key]?.subText2,
		color: data?.[key]?.color,
		percentageValue: percentage != null
			? `${percentage}`
			: null,
	};

}

export const getProductMapping = async (mappingType, storeId) => {
	const req = {
		data: {
			store: {
				id: storeId,
			},
			mappingTypes: [mappingType],
			categoryId: null,
			products: null,
		},
	};
	try {
		const response =
			await productProcessMapServices?.fetchProductWiseMappingData(
				req
			);
		if (response?.responseCode === 'SS-001') {
			// notificationServices.generateNotification({
			// 	type: 'success',
			// 	message: response?.responseMessage,
			// });
			const productIds = [];
			response?.data?.productwiseMappings?.forEach((ele) => {
				if (ele?.mappingTypeElementValue === '1') {
					productIds.push(ele?.productId);
				}
			});
			return productIds;
		}
	} catch (error) {
		console.log(error);
		return [];
	}
}

export const getPriceUnit = (
	variant,
	measurementType,
	productUnit,
	priceKey = 'costPrice'
) => {
	let itemPrice = variant?.[priceKey] || 0;
	let itemUnit = '';
	if (productUnit === 'count') {
		itemUnit = 'count';
		return [itemPrice, itemUnit];
	}
	if (productUnit === 'ltr') {
		itemUnit = 'ltr';
		return [itemPrice, itemUnit];
	}
	// if (productUnit === 'ml') {
	// itemUnit = 'ml';
	// return [itemPrice, itemUnit];
	// }

	if (productUnit === 'floz') {
		// if ((itemPrice * 128) > 1 && Number.isInteger(itemPrice * 128)) {
		if (itemPrice * 128 >= 1) {
			itemUnit = 'gal';
			itemPrice *= 128;
		} else {
			itemUnit = 'floz';
		}
		return [itemPrice, itemUnit];
	}
	if (productUnit === 'oz') {
		if (itemPrice * 16 > 1) {
			itemPrice *= 16;
			itemUnit = 'lbs';
		} else {
			itemUnit = 'oz';
		}
	}
	if (productUnit === 'gram') {
		if (itemPrice * 1000 > 1) {
			itemPrice *= 1000;
			itemUnit = 'kg';
		} else {
			itemUnit = 'g';
		}
	}
	if (productUnit === 'ml') {
		if (itemPrice * 1000 > 1) {
			itemPrice *= 1000;
			itemUnit = 'ltr';
		} else {
			itemUnit = 'ml';
		}
	}
	return [itemPrice, itemUnit];
};

// Helper function to get the display unit name
export const getHigherUnitName = (unit) => {
	if (!unit) return '';

	const normalizedUnit = unit.toLowerCase().trim();

	// Weight units
	if (normalizedUnit === 'gram' || normalizedUnit === 'g') return 'kg';
	if (normalizedUnit === 'mg' || normalizedUnit === 'milligram' || normalizedUnit === 'milligrams') return 'kg';
	if (normalizedUnit === 'kg' || normalizedUnit === 'kilogram' || normalizedUnit === 'kilograms') return 'kg';

	// Volume units
	if (normalizedUnit === 'ml' || normalizedUnit === 'milliliter' || normalizedUnit === 'milliliters') return 'ltr';
	if (normalizedUnit === 'cl' || normalizedUnit === 'centiliter' || normalizedUnit === 'centiliters') return 'ltr';
	if (normalizedUnit === 'dl' || normalizedUnit === 'deciliter' || normalizedUnit === 'deciliters') return 'ltr';
	if (normalizedUnit === 'l' || normalizedUnit === 'liter' || normalizedUnit === 'liters' || normalizedUnit === 'ltr' || normalizedUnit === 'litre') return 'ltr';

	// Length units
	if (normalizedUnit === 'mm' || normalizedUnit === 'millimeter' || normalizedUnit === 'millimeters') return 'm';
	if (normalizedUnit === 'cm' || normalizedUnit === 'centimeter' || normalizedUnit === 'centimeters') return 'm';
	if (normalizedUnit === 'm' || normalizedUnit === 'meter' || normalizedUnit === 'meters') return 'm';

	// Count units
	if (normalizedUnit === 'count' || normalizedUnit === 'piece' || normalizedUnit === 'pieces' || normalizedUnit === 'pcs') return 'pcs';
	if (normalizedUnit === 'oz' || normalizedUnit === 'ounce' || normalizedUnit === 'ounces') return 'lbs';
	if (normalizedUnit === 'floz' || normalizedUnit === 'fluid ounce' || normalizedUnit === 'fluid ounces') return 'gal';
	return unit; // Return original if no conversion
};

// get quantity in lower unit 
export const getUnitInLowerUnit = (unit, value) => {
	if (['kg', 'kilogram', 'kilograms'].includes(unit)) {
		return value * 1000
	}
	if (['g', 'gm', 'gram', 'grams'].includes(unit)) {
		return value
	}
	if (['ml', 'milliliter', 'milliliters'].includes(unit)) {
		return value
	}
	if (['ltr', 'liter', 'liters', 'litre'].includes(unit)) {
		return value * 1000
	}
	if (['lbs', 'pound', 'pounds'].includes(unit)) {
		return value * 16
	}
	if (['gal', 'gallon', 'gallons'].includes(unit)) {
		return value * 128
	}
	return value
}

export const getHigherUnitAndQuantity = (productUnit, value, isToFixed = true) => {
	const formatValue = (val) => isToFixed ? parseFloat(Number(val).toFixed(3)).toString() : val;
	if (['pc', 'count', 'piece', 'pieces', 'pcs'].includes(productUnit)) {
		return [value, 'pcs']
	}
	if (['kg', 'kilogram', 'kilograms'].includes(productUnit)) {
		return [value, 'kg']
	}
	if (['g', 'gm', 'gram', 'grams'].includes(productUnit)) {
		return [formatValue(value / 1000), 'kg']
	}
	if (['ml', 'milliliter', 'milliliters'].includes(productUnit)) {
		return [formatValue(value / 1000), 'ltr']
	}
	if (['ltr', 'liter', 'liters', 'litre'].includes(productUnit)) {
		return [value, 'ltr']
	}
	if (['oz', 'ounce', 'ounces'].includes(productUnit)) {
		return [formatValue(value / 16), 'lbs']
	}
	if (['floz', 'fluid ounce', 'fluid ounces'].includes(productUnit)) {
		return [formatValue(value / 128), 'gal']
	}
	if (['lbs', 'pound', 'pounds'].includes(productUnit)) {
		return [value, 'lbs']
	}
	if (['gal', 'gallon', 'gallons'].includes(productUnit)) {
		return [value, 'gal']
	}
	return [value, productUnit]
}

export const convertToLowerUnit = (productUnit, value) => {
	const numValue = parseFloat(value) || 0;
	if (['g', 'gm', 'gram', 'grams'].includes(productUnit)) {
		return numValue * 1000;
	}
	if (['ml', 'milliliter', 'milliliters'].includes(productUnit)) {
		return numValue * 1000;
	}
	if (['oz', 'ounce', 'ounces'].includes(productUnit)) {
		return numValue * 16;
	}
	if (['floz', 'fluid ounce', 'fluid ounces'].includes(productUnit)) {
		return numValue * 128;
	}
	return numValue;
}


export const getNavNameFromPath = (navState = {}, pathname = window?.location?.pathname, basePrefix = '/console2') => {
	let path = pathname || '';
	if (basePrefix && path.startsWith(basePrefix)) {
		path = path.slice(basePrefix.length) || '/';
	}

	let best = { len: -1, name: null };

	const consider = (href, name) => {
		if (!href) return;
		let h = href.startsWith(basePrefix) ? href.slice(basePrefix.length) : href;
		if (h && path.startsWith(h) && h.length > best.len) {
			best = { len: h.length, name };
		}
	};

	Object.entries(navState || {}).forEach(([key, value]) => {
		if (value && typeof value === 'object') {
			consider(value.href, value.name);
			if (value.submenu && typeof value.submenu === 'object') {
				Object.values(value.submenu).forEach((sub) => {
					if (sub && typeof sub === 'object') {
						consider(sub.href, sub.name);
					}
				});
			}
		}
	});

	if (!best.name) {
		let bestKey = '';
		Object.keys(navState || {}).forEach((key) => {
			if (key && path.startsWith(key) && key.length > bestKey.length) {
				bestKey = key;
			}
		});
		if (bestKey) best.name = navState?.[bestKey]?.name || bestKey;
	}

	return best.name || 'Export';
};

export const getFileName = (filters) => {
	if (filters?.dateRange) {
		filters['dateRangeFilter'] = filters?.dateRange;
		delete filters?.dateRange;
	}
	const navState = store.getState()?.navigation?.navState || {};
	const sectionName = getNavNameFromPath(navState, window.location.pathname, '/console2');

	const from = filters?.dateRangeFilter?.from ? moment(filters.dateRangeFilter.from).format('YYYY-MM-DD') : null;
	const to = filters?.dateRangeFilter?.to ? moment(filters.dateRangeFilter.to).format('YYYY-MM-DD') : null;
	const today = format(new Date(), 'yyyy-MM-dd');
	const base = from && to ? `${sectionName}-${from}_to_${to}` : `${sectionName}-${today}`;
	return `${base.replace(/[^\w\-]+/g, '_')}.csv`;
};

export const creditDebitDelta = 0.5;

export const getClosingTime = (openingTime, duration) => {
	if (!duration) return null;
	if (!openingTime) return null;
	const dHours = duration.getHours();
	const dMinutes = duration.getMinutes();
	const dSeconds = duration.getSeconds();

	const [openHour, openMinute] = openingTime.split(":").map(Number);
	const openingDate = new Date();
	openingDate.setHours(openHour, openMinute, 0, 0);

	const closingDate = new Date(openingDate);
	closingDate.setHours(openingDate.getHours() + dHours);
	closingDate.setMinutes(openingDate.getMinutes() + dMinutes);
	closingDate.setSeconds(openingDate.getSeconds() + dSeconds);

	let hr = closingDate.getHours();
	const min = closingDate.getMinutes().toString().padStart(2, "0");
	const meridian = hr >= 12 ? "PM" : "AM";
	hr = hr % 12 || 12;
	const closingTime12hr = `${hr}:${min} ${meridian}`;
	const isNextDay = moment(closingDate).format('DD') !== moment(openingDate).format('DD')
	return { closingTime12hr, isNextDay };
}

export const getDurationHours = (duration) => {
	if (!duration) return 0;
	const hours = duration.getHours();
	const minutes = duration.getMinutes();

	const totalHours = hours + (minutes / 60);
	return Math.round(totalHours * 10) / 10;
};
export const getMeridianTime = (time) => {
	const [hours, minutes] = time.split(':').map(Number);
	const meridian = hours >= 12 ? "PM" : "AM";
	const hr = hours % 12 || 12;
	return `${hr}:${minutes} ${meridian}`;
}
export const getHoursInDateObject = (hours) => {
	const date = new Date();
	let wholeHours = Math.floor(hours);
	let minutes = Math.round((hours - wholeHours) * 60);
	if (parseFloat(hours) >= 24) {
		wholeHours = 23;
		minutes = 0;
	}
	date.setHours(wholeHours, minutes, 0, 0);
	return date;
};

export function to24HourFormat(time12h) {
	const [time, modifier] = time12h.split(' ');
	let [hours, minutes] = time.split(':').map(Number);

	if (modifier.toLowerCase() === 'pm' && hours !== 12) {
		hours += 12;
	}
	if (modifier.toLowerCase() === 'am' && hours === 12) {
		hours = 0;
	}
	return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}
export function to12HourFormat(time24h) {
	let [hours, minutes] = time24h.split(':').map(Number);
	let meridian = 'AM';
	if (hours > 12) {
		hours -= 12;
		meridian = 'PM';
	}
	if (hours === 0) {
		hours = 12;
		meridian = 'AM';
	}
	if (hours === 12) {
		hours = 12;
		meridian = 'PM';
	}
	return `${String(Math.abs(hours)).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${meridian}`;
}
export const mealTypeList = [
	{ label: 'Breakfast', value: 55, mealType: 'breakfast' },
	{ label: 'Lunch', value: 56, mealType: 'lunch' },
	{ label: 'Dinner', value: 54, mealType: 'dinner' },
];
export const maskEmail = (email) => {
	return email.replace(/^(.{3}).*?@(.{3}).*?(\.[^.]+)$/, '$1****@$2****$3');
};

export const featureList = [
	{
		label: 'All',
		value: 'all',
	},
	{
		label: 'Yes',
		value: 'Yes',
	},
	{
		label: 'No',
		value: 'No',
	},
]
export const multiplePoCustomers = [52, '52'];

export const validateDateRange = (from, to) => {
	if (!from || !to) return false;

	const startDate = new Date(from);
	const endDate = new Date(to);

	if (isNaN(startDate) || isNaN(endDate)) return false;

	const diffInMs = endDate - startDate;
	const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

	return diffInDays > 31;
};

export const getCurrentPageNavInfo = (navState, currentPath) => {
	if (!navState) {
		return {
			subMenu: null,
			parentMenu: null,
			parentKey: null,
			subMenuKey: null,
		};
	}

	// Auto-calculate current path if not provided
	let pathToUse = currentPath;
	if (!pathToUse) {
		// Get current URL path and remove the extension prefix (e.g., '/console')
		const fullPath = window.location.pathname;
		// Find the extension in urls constants - typically '/console'
		const extensionMatch = fullPath.match(/^(\/[^\/]+)/);
		const extension = extensionMatch ? extensionMatch[1] : '';
		pathToUse = fullPath.slice(extension.length);
	}

	// Remove leading slash if present for consistency
	const cleanPath = pathToUse.startsWith('/') ? pathToUse : `/${pathToUse}`;

	// First, check if the current path is a top-level menu item
	if (navState[cleanPath]) {
		return {
			subMenu: navState[cleanPath],
			parentMenu: null,
			parentKey: null,
			subMenuKey: cleanPath,
		};
	}

	// If not found at top level, search in submenus
	for (const [parentKey, parentItem] of Object.entries(navState)) {
		// Skip if no submenu
		if (!parentItem?.submenu) continue;

		// Check if current path exists in this parent's submenu
		if (parentItem.submenu[cleanPath]) {
			return {
				subMenu: parentItem.submenu[cleanPath],
				parentMenu: parentItem,
				parentKey: parentKey,
				subMenuKey: cleanPath,
			};
		}
	}

	// Not found - return null values
	return {
		subMenu: null,
		parentMenu: null,
		parentKey: null,
		subMenuKey: null,
	};
};

export const hasValidDomain = (email, allowedDomains) => {
	if (allowedDomains?.length === 0 || !allowedDomains) return true;
	if (email?.includes('@')) {
		const modifyAllowedDomains = [...allowedDomains, 'udyogyantra.ai', 'udyogyantra.com'];
		const getDomain = email?.split?.('@')?.[1]?.toLowerCase();
		const hasValidDomain = (modifyAllowedDomains ?? [])?.some((domain) => domain?.toLowerCase() === getDomain)
		return hasValidDomain;
	}
	return false;
}

export const formatMetricValue = (value) => {
	if (!value && value !== 0) return null;
	const num = Number(value);
	if (num >= 1000000) {
		return `${(num / 1000000).toFixed(0)}M+`;
	} else if (num >= 1000) {
		return `${(num / 1000).toFixed(0)}K+`;
	}
	return `${num.toFixed(0)}+`;
};

export const removeKeyFromUrl = (key) => {
	const url = new URL(window.location.href);
	url.searchParams.delete(key);
	window.history.replaceState({}, "", url.toString());
};
export const day_map = {
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6,
	Sunday: 7
}
export const value_to_day_map = {
	1: 'Monday',
	2: 'Tuesday',
	3: 'Wednesday',
	4: 'Thursday',
	5: 'Friday',
	6: 'Saturday',
	7: 'Sunday'
};

export const yearDropDown = () => {
	const currentYear = new Date().getFullYear();
	const currentMonth = new Date().getMonth();
	const years = [];
	for (let i = currentMonth; i <= 11; i++) {
		const monthName = moment().month(i).format('MMMM');
		years.push({
			label: `${monthName} ${currentYear}`,
			value: i,
		});
	}
	return years;
}


export const checkNull = (value) => {
	if ([-999, '-999', '999', 999, undefined, null, ''].includes(value)) {
		return null;
	}
	if (Number(value) === 0) {
		return null;
	}
	return Number(value);
};

export const toTitleCase = (str) =>
	str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

export const everyWordTitleCase = (str) =>
	str.split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');

export const trackChnages = (originalRows, currentRows, trackKey) => {
	if (!originalRows || !currentRows) return originalRows;
	currentRows.forEach((item) => {
		const originalIndex = originalRows.findIndex((originalItem) => originalItem._variantId === item._variantId);
		if (originalIndex !== -1) {
			if (JSON.stringify(originalRows[originalIndex][trackKey]) !== JSON.stringify(item[trackKey])) {
				originalRows[originalIndex] = { ...item };
			}
		}
	});
	return originalRows;
}
export const compare = (a, b) => {
	const av = (a ?? '').toString().toLowerCase();
	const bv = (b ?? '').toString().toLowerCase();
	if (!av && bv) return 1;
	if (av && !bv) return -1;
	if (av < bv) return -1;
	if (av > bv) return 1;
	return 0;
};

export const unitMap = {
	1: 'gram',
	2: 'count',
	3: 'litre',
	4: 'oz',
	5: 'floz',
	6: 'ml',
};

/* -------------------------------------------------------------------------- */
/* Excel / clipboard paste helpers                                            */
/* -------------------------------------------------------------------------- */

// "Aam Katli - 006166" -> "006166"
export const extractEmbeddedSku = (name) => {
	const m = String(name || '').match(/-\s*([A-Za-z0-9]+)\s*$/);
	return m ? m[1] : '';
};

// Strips newlines, a trailing "- SKU" and collapses whitespace.
export const cleanPastedName = (name) => String(name || '')
	.replace(/\n/g, ' ')
	.replace(/-\s*[A-Za-z0-9]+\s*$/, '')
	.replace(/\s+/g, ' ')
	.trim();

// Groups a unit into weight / volume / count so a pasted unit is only converted
// when it belongs to the same family as the product's own unit.
export const getUnitFamily = (unit) => {
	const x = String(unit || '').toLowerCase().trim();
	if (['kg', 'kilogram', 'kilograms', 'g', 'gm', 'gram', 'grams', 'lbs', 'pound', 'pounds'].includes(x)) return 'wt';
	if (['ml', 'milliliter', 'milliliters', 'ltr', 'l', 'liter', 'liters', 'litre', 'gal', 'gallon', 'gallons', 'floz'].includes(x)) return 'vol';
	return 'count';
};

/**
 * Parses tab/comma separated clipboard text into rows.
 *
 * Columns are read by HEADER name first (handles wide exports where the columns
 * aren't in a fixed position); headers are normalised so "productionPlan" and
 * "Production Plan" both match. Falls back to positional
 * [name, (sku), unit, qty] when no usable header row is present.
 *
 * `qtyColumns` makes the value column DYNAMIC: pass the header names of the
 * column to pick, e.g. ['closingStock'] picks the Excel "Closing Stock" column
 * (normalisation makes 'closingStock' ≡ 'Closing Stock'). The picked value is
 * still returned as `qty` — the caller maps it onto its own field. Without it
 * the default qty headers (production plan / qty / quantity) are used.
 *
 * `skuColumns` prepends sheet-specific SKU headers (e.g. ['item code']) ahead of
 * the default ones, for exports that don't call the column "SKU Code".
 *
 * @returns {Array<{name: string, sku: string, unit: string, qty: number}>}
 */
export const parsePastedTable = (text, qtyColumns = [], extraColumns = [], skuColumns = []) => {
	const splitLine = (l) => (l.includes('\t') ? l.split('\t') : l.split(',')).map((c) => String(c).trim());
	const lines = String(text || '').split(/\r?\n/).filter((l) => l && l.trim());
	if (!lines.length) return [];

	const normH = (h) => String(h || '').toLowerCase().replace(/[^a-z0-9]/g, '');
	const headerCells = splitLine(lines[0]).map(normH);
	// Exact match first (by key priority), then a contains fallback — so
	// "productionplan" is chosen over "issuedquantity" for the qty column.
	const findIdx = (keys) => {
		const nk = keys.map(normH);
		for (const k of nk) {
			const i = headerCells.findIndex((h) => h === k);
			if (i >= 0) return i;
		}
		for (const k of nk) {
			const i = headerCells.findIndex((h) => h.includes(k));
			if (i >= 0) return i;
		}
		return -1;
	};
	const nameIdx = findIdx(['product name', 'productname', 'item name', 'name']);
	const unitIdx = findIdx(['uom', 'unit']);
	// Caller-provided value column wins (e.g. ['closingStock']); default = qty.
	const qtyIdx = findIdx((Array.isArray(qtyColumns) && qtyColumns.length)
		? qtyColumns
		: ['production plan', 'productionplan', 'qty', 'quantity']);
	// Only treat an explicit SKU header as SKU (NOT a generic "code" column).
	const skuIdx = findIdx([
		...(Array.isArray(skuColumns) ? skuColumns : []),
		'skucode', 'sku code', 'sku', 'client variant', 'clientvariantid',
	]);
	// Optional extra value columns (e.g. AI recommend production qty) captured
	// alongside the primary qty column. Header-based only.
	const extraIdx = (Array.isArray(extraColumns) ? extraColumns : [])
		.map((ec) => ({ key: ec?.key, idx: findIdx(ec?.aliases || []) }))
		.filter((e) => e.key && e.idx >= 0);
	const hasHeader = nameIdx >= 0 && (qtyIdx >= 0 || extraIdx.length > 0);

	const rows = [];
	(hasHeader ? lines.slice(1) : lines).forEach((line) => {
		let name = '';
		let sku = '';
		let unit = '';
		let qty = null;
		const extras = {};
		if (hasHeader) {
			const cells = splitLine(line);
			name = cells[nameIdx] || '';
			unit = unitIdx >= 0 ? (cells[unitIdx] || '') : '';
			sku = skuIdx >= 0 ? (cells[skuIdx] || '') : '';
			
			// A cell with no digits at all (e.g. '-') means "no value", not 0.
			const qtyStr = qtyIdx >= 0 ? String(cells[qtyIdx] || '').trim().replace(/[^0-9.]/g, '') : '';
			qty = qtyStr !== '' ? Number(qtyStr) : null;

			extraIdx.forEach(({ key, idx }) => {
				const extraStr = String(cells[idx] || '').trim().replace(/[^0-9.]/g, '');
				extras[key] = extraStr !== '' ? Number(extraStr) : null;
			});
		} else {
			const cells = splitLine(line);
			while (cells.length && cells[cells.length - 1] === '') cells.pop();
			if (cells.length < 2) return;
			let qtyRaw = '';
			if (cells.length >= 4) {
				[name, sku, unit, qtyRaw] = cells;
			} else if (cells.length === 3) {
				[name, unit, qtyRaw] = cells;
			} else {
				[name, qtyRaw] = cells;
			}
			const qtyStr = String(qtyRaw || '').trim().replace(/[^0-9.]/g, '');
			qty = qtyStr !== '' ? Number(qtyStr) : null;
		}
		const hasValidQty = qty !== null && !Number.isNaN(qty);
		const hasValidExtra = Object.values(extras).some((v) => v !== null && !Number.isNaN(v));
		if (!hasValidQty && !hasValidExtra) return;
		rows.push({ name, sku, unit, qty, ...extras });
	});
	return rows;
};

/**
 * Resolves one pasted row to a product variant: SKU match first, then a fuzzy
 * name match, then a "contains" fallback.
 *
 * `fuzzyMatcher` is injected (rather than imported) to keep this helper free of
 * component dependencies — pass `matchIngredientToProduct` from
 * MultiRecipeEditModal, or omit it to use SKU + contains matching only.
 *
 * @returns {{row: object|null, candidates?: Array}} `candidates` is set when the
 * name matched more than one product and the user must pick.
 */
export const matchPastedRowToProduct = ({
	name: nameRaw,
	sku: skuRaw,
	flattenedProducts = [],
	productList = [],
	fuzzyMatcher = null,
}) => {
	const norm = (x) => String(x ?? '').trim().toLowerCase();
	const skusOf = (p) => [
		p?.skuCode, p?.clientVariantId, p?.skuId, p?.articleCode, p?.id, p?.variantId,
	].map(norm).filter(Boolean);

	const pastedSkus = [norm(skuRaw), norm(extractEmbeddedSku(nameRaw))].filter(Boolean);
	if (pastedSkus.length) {
		const bySku = flattenedProducts.find((p) => skusOf(p).some((s) => pastedSkus.includes(s)));
		if (bySku) return { row: bySku };
	}

	const rawName = cleanPastedName(nameRaw);
	if (!rawName) return { row: null };

	let cleanName = norm(rawName).replace(/\s+/g, ' ');
	const nameNoParen = cleanName.replace(/\s*\([^()]*\)$/, '').trim();
	const exactMatches = flattenedProducts.filter((p) => {
		const pn = norm(p?.productName).replace(/\s+/g, ' ');
		const pv = norm(p?.variantName).replace(/\s+/g, ' ');
		const fullName = pv && pv !== '-' ? `${pn} (${pv})` : pn;
		return pn === cleanName || fullName === cleanName
			|| (nameNoParen && nameNoParen !== cleanName
				&& (pn === nameNoParen || fullName === nameNoParen));
	});
	if (exactMatches.length === 1) return { row: exactMatches[0] };
	if (exactMatches.length > 1) {
		return {
			row: null,
			candidates: exactMatches.map((p) => ({
				productId: p.productId,
				variantId: p.variantId,
				label: p.variantName && p.variantName !== '-' ? `${p.productName} (${p.variantName})` : p.productName,
			})),
		};
	}

	if (fuzzyMatcher) {
		const m = fuzzyMatcher(rawName, productList);
		if (m?.status === 'matched' || m?.status === 'partial') {
			if (m?.variant?.id != null) {
				const byVariant = flattenedProducts.find((p) => p?.variantId === m.variant.id);
				if (byVariant) return { row: byVariant };
			}
			if (m?.product?.id != null) {
				const byProduct = flattenedProducts.find((p) => p?.productId === m.product.id);
				if (byProduct) return { row: byProduct };
			}
		}
		// Multiple products share the first two words → ask the user which one.
		if (m?.status === 'ambiguous' && m?.candidates?.length) {
			return { row: null, candidates: m.candidates };
		}
	}

	// Contains fallback (spaces normalised). One hit = match, many hits = ambiguous.
	cleanName = norm(rawName).replace(/\s+/g, ' ');
	const matches = flattenedProducts.filter((p) => {
		const pn = norm(p?.productName).replace(/\s+/g, ' ');
		return pn === cleanName || pn.includes(cleanName) || cleanName.includes(pn);
	});
	if (matches.length === 1) return { row: matches[0] };
	if (matches.length > 1) {
		return {
			row: null,
			candidates: matches.map((p) => ({ productId: p.productId, variantId: p.variantId, label: p.productName })),
		};
	}
	return { row: null };
};

/**
 * Typo-tolerant "contains" check for search boxes. Returns the fewest
 * single-character edits (insert, delete, substitute, swap two adjacent) that
 * turn `query` into some substring of `text`, or -1 when that exceeds the
 * tolerance for the query's length: none under 5 chars, 1 up to 8, 2 beyond.
 * 0 means a plain substring hit, so callers can rank exact matches first.
 * e.g. ('sfores', 'My Outlets/Stores') -> 1, ('stores', 'Stores') -> 0.
 */
export function fuzzySearchDistance(query, text) {
	const q = String(query ?? '').trim().toLowerCase();
	const t = String(text ?? '').toLowerCase();
	if (!q || t.includes(q)) return 0;
	let maxEdits = 2;
	if (q.length < 5) maxEdits = 0;
	else if (q.length < 9) maxEdits = 1;
	if (!maxEdits) return -1;

	// Edit-distance table over query (rows) x text (columns). Row 0 is all
	// zeros and the answer is the minimum of the last row, so the match can
	// start and end anywhere in `text`.
	let prevPrev = null;
	let prev = new Array(t.length + 1).fill(0);
	for (let i = 1; i <= q.length; i++) {
		const curr = [i];
		for (let j = 1; j <= t.length; j++) {
			const cost = q[i - 1] === t[j - 1] ? 0 : 1;
			let best = Math.min(prev[j] + 1, curr[j - 1] + 1, prev[j - 1] + cost);
			if (i > 1 && j > 1 && q[i - 1] === t[j - 2] && q[i - 2] === t[j - 1]) {
				best = Math.min(best, prevPrev[j - 2] + 1);
			}
			curr.push(best);
		}
		prevPrev = prev;
		prev = curr;
	}
	const distance = Math.min(...prev);
	return distance <= maxEdits ? distance : -1;
}
